import { useMemo } from "react";
import { queryClient } from "App";
import useAuthorized from "hooks/useAuthorized";
import {
  CAN_EDIT_CONTACT_PERMISSIONS,
  CAN_SET_CAMPAIGN_TARGET_PERMISSIONS,
  getReferralContactsTableColumns,
} from "routes/dial_sessions/components/ReferralContactsTable/ReferralContactsTableColumnsAndFilters";
import { REFERRAL_CONTACTS_TABLE_CONSTANTS } from "routes/dial_sessions/components/ReferralContactsTable/ReferralContactsTableV3";

const SET_CAMPAIGN_TARGET_AUTH_PARAMS = { partialMatch: true };

export const invalidateReferralContactsQuery = () => {
  queryClient.invalidateQueries({
    queryKey: [REFERRAL_CONTACTS_TABLE_CONSTANTS.queryKey],
  });
};

export const useReferralContactsTable = ({
  campaign_id,
  entity_id,
  callNextContact,
}) => {
  const canSetCampaignTarget = useAuthorized(
    CAN_SET_CAMPAIGN_TARGET_PERMISSIONS,
    SET_CAMPAIGN_TARGET_AUTH_PARAMS
  );
  const canEditContact = useAuthorized(CAN_EDIT_CONTACT_PERMISSIONS);

  const columns = useMemo(
    () =>
      getReferralContactsTableColumns({
        campaign_id,
        entity_id,
        callNextContact,
        onContactUpdated: invalidateReferralContactsQuery,
        canSetCampaignTarget,
        canEditContact,
      }),
    [
      campaign_id,
      entity_id,
      callNextContact,
      canSetCampaignTarget,
      canEditContact,
    ]
  );

  return {
    columns,
  };
};
